import { Box, Image } from "@chakra-ui/react";
import React from "react";
import useWebsiteInfo from "../../../hook/useWebsiteInfo";
import { Link } from "react-router-dom";

const LngButton = () => {
  const { images } = useWebsiteInfo();

  return (
    <Box
      as={Link}
      to="language"
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={images.lngIcon}
        height={{
          base: "40px",
          sm: "50px",
          md: "60px",
        }}
        minW={{
          base: "40px",
          sm: "50px",
          md: "60px",
        }}
      />
    </Box>
  );
};

export default LngButton;
